import { Routes } from '@angular/router';
import { AuthGuard, PublicRoutes } from '@core/guard/auth.guard';
import { AdminAuthGuard, AdminPublicRoutes } from '@admin/configs/admin.auth.guard';

export const routes: Routes = [
  { path:'', redirectTo:'home', pathMatch: 'full' },
  {
    path: 'home',
    loadComponent: () => import('./landingpage/landingpage/landingpage.component').then(m => m.LandingpageComponent)
  },
  {
    path: 'contactus',
    loadComponent: () => import('./landingpage/landing-contactus/landing-contactus.component').then(m => m.LandingContactusComponent)
  },
  {
    path: 'signup',
    loadComponent: () => import('./core/auth/pages/signup/signup.component').then(m => m.SignupComponent),
    canActivate: [PublicRoutes],
  },
  {
    path: 'login',
    loadComponent: () => import('./core/auth/pages/login/login.component').then(m => m.LoginComponent),
    canActivate: [PublicRoutes],
  },
  {
    path: 'forgotpassword',
    loadComponent: () => import('./core/auth/pages/forgotpassword/forgotpassword.component').then(m => m.ForgotpasswordComponent),
    canActivate: [PublicRoutes],
  },
  {
    path: 'confirm_email',
    loadComponent: () => import('./core/auth/pages/confirmemail/confirmemail.component').then(m => m.ConfirmemailComponent),
    canActivate: [PublicRoutes],
  },
  {
    path: 'reset_password',
    loadComponent: () => import('./core/auth/pages/resetpassword/resetpassword.component').then(m => m.ResetpasswordComponent),
    canActivate: [PublicRoutes],
  },
  {
    path: 'set_password',
    loadComponent: () => import('./core/auth/pages/set-password/set-password.component').then(m => m.SetPasswordComponent),
  },
  {
    path: '2fa',
    loadComponent: () => import('./core/auth/pages/two-factor-auth/two-factor-auth.component').then(m => m.TwoFactorAuthComponent),
  },
  {
    path: 'accept_team',
    loadComponent: () => import('./pages/invitations/accept-team/accept-team.component').then(m => m.AcceptTeamComponent)
  },
  {
    path: 'privacy_policy',
    loadComponent: () => import('./shared/pages/privacy/privacy.component').then(m => m.PrivacyComponent)
  },
  {
    path: 'terms_conditions',
    loadComponent: () => import('./shared/pages/terms/terms.component').then(m => m.TermsComponent)
  },
  {
    path: 'gdpr_compliance',
    loadComponent: () => import('./shared/pages/gdpr/gdpr.component').then(m => m.GdprComponent)
  },
  {
    path: 'tour_guide',
    loadComponent: () => import('./shared/pages/tourguide/tour-guide.component').then(m => m.TourGuideComponent)
  },
  {
    path: 'app',
    canActivate: [AuthGuard],
    loadComponent: () => import('./pages/app-layout/app-layout.component').then(m => m.AppLayoutComponent),
    children: [
      {
        path: 'teams',
        loadComponent: () => import('./pages/teams/teams-listing/teams-listing.component').then(m => m.TeamsListingComponent)
      },
      {
        path: 'create_team',
        loadComponent: () => import('./pages/teams/create-team/create-team.component').then(m => m.CreateTeamComponent)
      },
      {
        path: 'team_overview/:id',
        loadComponent: () => import('./pages/teams/team-overview/team-overview.component').then(m => m.TeamOverviewComponent),
      },
      {
        path: 'master_plan/:id',
        loadComponent: () => import('./pages/master-plan/masterplans/masterplans.component').then(m => m.MasterplansComponent)
      },
      {
        path: 'invitations/:id',
        loadComponent: () => import('./pages/invitations/invitation-list/invitation-list.component').then(m => m.InvitationListComponent)
      },
      {
        path: 'notes/:id',
        loadComponent: () => import('./pages/notes/notes-listing/notes-listing.component').then(m => m.NotesListingComponent)
      },
      {
        path: 'peoples',
        loadComponent: () => import('./pages/people/peoples-listing/peoples-listing.component').then(m => m.PeoplesListingComponent)
      },
      {
        path: 'peoples/:id',
        loadComponent: () => import('./pages/people/peoples-listing/peoples-listing.component').then(m => m.PeoplesListingComponent)
      },
      {
        path: 'notes',
        loadComponent: () => import('./pages/notes/notes-listing/notes-listing.component').then(m => m.NotesListingComponent)
      },
      {
        path: 'account_settings',
        loadComponent: () => import('./pages/account-settings/settings/settings.component').then(m => m.SettingsComponent)
      },
      {
        path: 'calendar/:id',
        loadComponent: () => import('./capp/calendar/calendar.component').then(m => m.CalendarComponent)
      }
    ],
  },
  { path:'adminpanel', redirectTo:'adminpanel/login', pathMatch: 'full' },
  {
    path: 'adminpanel',
    loadComponent: () => import('./adminPanel/shared/components/adminpanel-layout/adminpanel-layout.component').then(m => m.AdminpanelLayoutComponent),
    children: [
      {
        path: 'login',
        loadComponent: () => import('./adminPanel/pages/auth/admin-login/admin-login.component').then(m => m.AdminLoginComponent),
        canActivate: [AdminPublicRoutes],
      },
      {
        path: 'forgotpassword',
        loadComponent: () => import('./adminPanel/pages/auth/admin-forgotpassword/admin-forgotpassword.component').then(m => m.AdminForgotpasswordComponent),
        canActivate: [AdminPublicRoutes],
      },
      {
        path: 'resetpassword',
        loadComponent: () => import('./adminPanel/pages/auth/admin-resetpassword/admin-resetpassword.component').then(m => m.AdminResetpasswordComponent),
        canActivate: [AdminPublicRoutes],
      },
      {
        path: 'setpassword',
        loadComponent: () => import('./adminPanel/pages/auth/admin-setpassword/admin-setpassword.component').then(m => m.AdminSetpasswordComponent),
        canActivate: [AdminPublicRoutes],
      },
      {
        path: '2fa',
        loadComponent: () => import('./adminPanel/pages/auth/admin-twofactorauthentication/admin-twofactorauthentication.component').then(m => m.AdminTwofactorauthenticationComponent),
        canActivate: [AdminPublicRoutes],
      },
      {
        path: 'app',
        loadComponent: () => import('./adminPanel/shared/components/dashboard-layout/dashboard-layout.component').then(m => m.DashboardLayoutComponent),
        canActivate: [AdminAuthGuard],
        children: [
          {
            path: 'dashboard',
            loadComponent: () => import('./adminPanel/pages/dashboard/dashboard.component').then(m => m.DashboardComponent),
          },
          {
            path: 'systemadmin',
            loadComponent: () => import('./adminPanel/pages/admins/list-admins/list-admins.component').then(m => m.ListAdminsComponent),
          },
          {
            path: 'corporateadmin',
            loadComponent: () => import('./adminPanel/pages/admins/list-admins/list-admins.component').then(m => m.ListAdminsComponent),
          },
          {
            path: 'addsystemadmin',
            loadComponent: () => import('./adminPanel/pages/admins/add-edit-admin/add-edit-admin.component').then(m => m.AddEditAdminComponent),
          },
          {
            path: 'addcorporateadmin',
            loadComponent: () => import('./adminPanel/pages/admins/add-edit-admin/add-edit-admin.component').then(m => m.AddEditAdminComponent),
          },
          {
            path: 'editsystemadmin/:id',
            loadComponent: () => import('./adminPanel/pages/admins/add-edit-admin/add-edit-admin.component').then(m => m.AddEditAdminComponent),
          },
          {
            path: 'editcorporateadmin/:id',
            loadComponent: () => import('./adminPanel/pages/admins/add-edit-admin/add-edit-admin.component').then(m => m.AddEditAdminComponent),
          },
          {
            path: 'domains',
            loadComponent: () => import('./adminPanel/pages/domains/list-domains/list-domains.component').then(m => m.ListDomainsComponent),
          },
          {
            path: 'adddomains',
            loadComponent: () => import('./adminPanel/pages/domains/add-edit-domain/add-edit-domain.component').then(m => m.AddEditDomainComponent),
          },
          {
            path: 'editdomains/:id',
            loadComponent: () => import('./adminPanel/pages/domains/add-edit-domain/add-edit-domain.component').then(m => m.AddEditDomainComponent),
          },
          {
            path: 'listteams',
            loadComponent: () => import('./adminPanel/pages/organization-teams/list-organization-teams/list-organization-teams.component').then(m => m.ListOrganizationTeamsComponent),
          },
          {
            path: 'feedbacks',
            loadComponent: () => import('./adminPanel/pages/feedback/list-feedback/list-feedbacks.component').then(m => m.ListFeedbacksComponent),
          },
          {
            path:'editfeedback/:id',
            loadComponent: () => import('./adminPanel/pages/feedback/edit-feedback/edit-feedback.component').then(m => m.EditFeedbackComponent),
          },
          {
            path: 'users',
            loadComponent: () => import('./adminPanel/pages/users/list-users/list-users.component').then(m => m.ListUsersComponent),
          }
        ],
      },
    ],
  }
];
